<script setup lang="ts">

defineProps<{
  numbersArray: Array<number>,
    animationOn: boolean,
}>();

</script>

<template>
  <div class="counter">
    <div v-for="(number, index) in numbersArray" :key="index" class="counter__unit" data-js="counter-tens">
      <span :class="['counter__number', 'bg-green-30',animationOn && 'moving']">
        <span class="current">{{ number }}</span>
      </span>
      <span :class="['counter__number', 'bg-green-30', animationOn && 'moving']">
        <span class="next">{{ number }}</span>
      </span>
    </div>
  </div>
</template>

<style scoped>
@import '~/assets/css/mixins/_mixins.index.pcss';

.counter {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 55px;
  overflow: hidden;

  @screen tablet-wide {
    height: 60px;
  }

  &__unit {
    display: flex;
    flex-direction: column;
    margin: 0 4px;
  }

  &__number {
    @mixin h2;
    border-radius: 8px;
    color: theme('colors.primary.30');
    margin-bottom: 10px;
    text-align: center;
    width: 48px;
    height: 48px;
    padding: 5px 0;
    @screen tablet-wide {
      width: 52px;
      height: 52px;
      margin-bottom: 20px;
      padding: 0;
    }
  }

  .moving {
    transform: translateY(-50px);

    @screen tablet-wide {
      transform: translateY(-65px);
    }
  }
}
</style>
